define([
  "app/control/uploader",
  "app/modules/language",
  "app/modules/forms",
  "app/modules/user",
  "app/modules/local_storage",
  "app/modules/employmentHistory",
  "app/modules/nestedFields"
], function(
  Uploader,
  Language,
  Forms,
  User,
  LocalStorage,
  EmploymentHistory,
  NestedFields
) {
  var Students = function() {
    this.actionCreate = this.actionNew;
  };

  Students.prototype.actionNew = function() {
    LocalStorage.loadForm(
      "student",
      $("#new_student")
        .attr("action")
        .split("/")[4]
    );
    var uplPhoto = new Uploader($("#student_user_photo"), {
      type: "image",
      autoUpload: true
    });
    var uplResume = new Uploader($("#student_user_resume"), {
      type: "file",
      autoUpload: true
    });

    $(".add-language").on("click", function(e) {
      e.preventDefault();
      Language.add(null, "student");
    });

    $(".languages-list").on("click", ".remove-language", function(e) {
      e.preventDefault();
      Language.remove($(this));
    });

    $(".new_student").on("submit", function(e) {
      e.preventDefault();
      Forms.submitWithFiles($(this), "student_");
    });

    $(".modal#sign-in-modal form#new_user").on("submit", function(e) {
      e.preventDefault();
      e.stopPropagation();
      User.signIn($(e.currentTarget), "user_");
    });

    Forms.bindSharedControls();

    new EmploymentHistory({
      $container: $(".js-employments-fields"),
      resourceName: "student"
    });

    new NestedFields();
  };

  Students.prototype.actionCreate = function() {};
  Students.prototype.actionIndex = function() {};

  return Students;
});
